// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UmTy","comment":"styles_comment__Va6Io"};